import React, { useState } from 'react';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import ClickableElement from '../../../ClickableElement';
import ReportListItem from '../ReportListItem';
import ReadMoreBtn from '../../../common/ReadMoreBtn';

import { ACTIONS } from '../../../../constants/strings';
import { withErrorBoundary } from '../../../../hocs/withErrorBoundary';

import styles from '../index.styl';

const ReportList = ({ list, intl: { formatMessage }, onSelect }) => {
  const [showFull, setShowFull] = useState(false);
  const [selected, setSelected] = useState(null);

  const rootList = showFull ? list : list.filter(item => !item.extra);
  const hasMore = rootList.length !== list.length;

  const textBtn = `${formatMessage(ACTIONS.program.more)}...`;

  const handleClickItem = ({ id }) => {
    setSelected(id);
    onSelect(id);
  };

  return (
    <div>
      {rootList.map(item => (
        <ClickableElement key={item.id} onClick={() => handleClickItem(item)}>
          <ReportListItem item={item} selected={selected} />
        </ClickableElement>
      ))}
      {hasMore && !showFull && (
        <ReadMoreBtn
          styleName="list-btn"
          onClick={() => setShowFull(true)}
          children={textBtn}
        />
      )}
    </div>
  );
};

ReportList.propTypes = {
  list: PropTypes.array.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default compose(
  withErrorBoundary,
  injectIntl,
  CSSModules(styles, { allowMultiple: true }),
)(ReportList);



// WEBPACK FOOTER //
// ./src/components/Ui/Report/ReportList/index.jsx